import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';

export interface ISectionSwapToFrom {
  id: number;
  course?: number;
  session?: number;
  section_type: number;
}
export interface ISectionSwapModel {
  course: number;
  from_section: ISectionSwapToFrom;
  swap_from_section_ids: ISectionSwapToFrom[];
  swap_to_section_ids: ISectionSwapToFrom[];
  isMultiSection: boolean;
  session: string;
}

export type SectionSwapModel = ITypedModel<ISectionSwapModel>;

angular.module('capability-ng-scheduler').factory(
  'ngCourseSectionSwapModel',
  () =>
    new Model<ISectionSwapModel>({
      course: -1,
      isMultiSection: false,
      session: '',
      from_section: {
        id: -1,
        section_type: -1
      },
      swap_from_section_ids: [],
      swap_to_section_ids: []
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/models/course_section_swap_model.ts